import React, { useCallback, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { DataSource } from '@europrocurement/l2d-redux-utils';

import { ExceptionFacturante } from '@europrocurement/l2d-domain/reducers/achats/slices/exceptionFacturante';
import { Box } from '@mui/material';
import { addItem, publisherIcon } from '@europrocurement/l2d-icons';
import { ActionButton, ListingTitle, useModal } from '@europrocurement/flexy-components';
import {
    ExceptionFacturanteSelector,
    FournisseurApi,
    useAchatsService,
} from '@europrocurement/l2d-domain';

import { AppDispatch } from '../../../../redux/types';

import CreateExceptionForm from '../../../Fournisseurs/views/detail/Publisher/tabs/PurchaseInvoiceSettings/fragments/CreateExceptionForm';
import ExceptionsFacturantesListComponent from '../../components/lists/ExceptionsFacturantesListComponent';

export type PublishersRejectCodesListProps = {
    publisher: FournisseurApi;
};

const PublishersRejectCodesList: React.FunctionComponent<PublishersRejectCodesListProps> =
    function ({ publisher }) {
        const { getExceptionFacturante } = useAchatsService();

        const exceptionsFacturantesDataSource: DataSource<ExceptionFacturante> = useSelector(
            ExceptionFacturanteSelector,
        ).main;

        const dispatch = useDispatch<AppDispatch>();
        const { modalActions } = useModal();
        const reloadList = useCallback(() => {
            dispatch({
                type: `${exceptionsFacturantesDataSource.slicename}/set${exceptionsFacturantesDataSource.name}Filter`,
                payload: {
                    key: 'idFacturante',
                    value: publisher.id,
                },
            });
            setTimeout(() => {
                dispatch(getExceptionFacturante({}));
            }, 500);
        }, [
            dispatch,
            exceptionsFacturantesDataSource.name,
            exceptionsFacturantesDataSource.slicename,
            getExceptionFacturante,
            publisher.id,
        ]);

        useEffect(() => {
            reloadList();
        }, [reloadList]);

        const actionAfterSubmitCreateExceptionForm = useCallback(() => {
            reloadList();
            modalActions.close();
        }, [modalActions, reloadList]);

        const handleOnClickCreatePublisherException = useCallback<
            NonNullable<React.ComponentProps<typeof ActionButton>['action']>
        >(() => {
            modalActions.call(
                <CreateExceptionForm afterSubmit={actionAfterSubmitCreateExceptionForm} />,
            );
        }, [modalActions, actionAfterSubmitCreateExceptionForm]);

        return (
            <Box>
                <Box display="flex">
                    <ListingTitle
                        modelIcon={publisherIcon}
                        title="Liste des exceptions associées au fournisseur"
                    />
                    <ActionButton
                        label="Créer une exception"
                        icon={addItem}
                        action={handleOnClickCreatePublisherException}
                    />
                </Box>
                <Box display="flex">
                    <ExceptionsFacturantesListComponent
                        filtersControl
                        dataSource={exceptionsFacturantesDataSource}
                        fetchData={getExceptionFacturante}
                    />
                </Box>
            </Box>
        );
    };

export default PublishersRejectCodesList;
